export class HelperVar {
    static defaultVar(e: string | undefined): string {
        return e === undefined || e === '' ? '-' : e;
    }

    static getShortFIO(fio: string) {
        let result = '';
        if(fio){
            let arF = fio.split(' ');
            result = arF[0];
            if(arF[1]){
                result+=' '+arF[1].substr(0,1)+'.';
            }
            if(arF[2]){
                result+=' '+arF[2].substr(0,1)+'.';
            }
        }
        return result;
    }

}